import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'
import { Tooltip } from '@src/elements/tooltip/tooltip'
import { isMobileBrowser } from '@src/util/functions'

@Component
export class MobileTooltip extends Vue {

  @Prop({ required: true })
    content: string

  constructor () {
    super()
  }

  render (h: CreateElement) {
    if (isMobileBrowser()) {
      return (<div class={'tooltip-mobile-wrapper'}>
       <div>{this.$slots.default}</div>
       <div class={'tooltip-mobile-text'}>{this.content}</div>
     </div>)
    }
    return (<Tooltip content={this.content}>{this.$slots.default}</Tooltip>)
  }
}
